<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/3wVlRy/images/cover.jpg?1733067596038" alt="This image is the cover for the book Raiders of Gor, Gorean Saga"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Raiders of Gor, Gorean Saga
      </h1>
      <p class="bookDescription body article font2">
        <b>Strapping warriors sail through the seas of a Counter Earth—where the powerful have every fantasy fulfilled—in this cult classic sci-fi adventure series.</b><br/><br/> Former Earthman Tarl Cabot finds himself in the most depraved city on Gor. Port Kar is a city of robbers, brigands, and men without allegiance to any cause or kingdom where the weak are quickly consumed by the strong. However, Tarl is able to flourish in the cutthroat environment of the city, for he is a powerful Tarnsman used to having his way. He finds that there is much to learn in Port Kar, where the people are celebrated for their skill of training their voluptuous slaves into utter obedience.<br/>  <br/> Rediscover this brilliantly imagined world where men are masters and women live to serve their every desire.<br/>  <br/><b><i>Raiders of Gor </i></b><b>is the 6th book in the Gorean Saga, but you may enjoy reading the series in any order. </b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        John Norman
      </h2>
      
      <p class="authorDescription body article">John Norman is the creator of the Gorean Saga, the longest-running series of adventure novels in science fiction history. He is also the author of the science fiction series the Telnarian Histories, as well as <I>Ghost Dance</I>, <I>Time Slave</I>, <I>The Totems of Abydos</I>, <I>Imaginative Sex</I>, and <I>Norman Invasions</I>. Norman is married and has three children.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4cfb05a1